import {PaymentMethod} from '@stripe/stripe-js';

import {ShoppersWalletDto, WalletDto} from 'types/Dto';

import {formatEndpoint} from 'utils/Api';
import {GET, POST} from 'utils/Http';

export const fetchShopperPaymentMethods = () => {
  return GET<PaymentMethod[]>(formatEndpoint('SHOPPERS_PAYMENT_METHODS'));
};

export const removePaymentMethods = (paymentMethodId: string) => {
  return POST(formatEndpoint('SHOPPERS_REMOVE_PAYMENT_METHODS'), {
    payment_method_id: paymentMethodId,
  });
};

// WALLETS

export type FetchShopperWalletsDto = {
  type?: WalletDto['type'];
};
export const fetchShopperWallets = async (type: WalletDto['type']) => {
  return GET<ShoppersWalletDto[], FetchShopperWalletsDto>(
    formatEndpoint('SHOPPERS_WALLETS'),
    {
      type,
    },
  );
};

export type CreateShopperWalletsDto = {
  account_id: string;
  type: WalletDto['type'];
};

export const createShopperWallet = async (
  createShopperWalletsDto: CreateShopperWalletsDto,
) => {
  return POST<ShoppersWalletDto, CreateShopperWalletsDto>(
    formatEndpoint('SHOPPERS_WALLETS'),
    {
      ...createShopperWalletsDto,
    },
  );
};
